import { useState, useCallback } from 'react';
import { phoneNumber } from '../data/mock';

const useCityForm = (cityName) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
    city: cityName || ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }, []);

  const resetForm = useCallback((city) => {
    setFormData({ name: '', phone: '', message: '', city: city || '' });
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            'send_to': 'AW-17907693435/cCzoCMjgfAbEPvuhttC'
          });
        }
        setSubmitMessage('Merci ! Votre demande a été envoyée. Le Grand Marabout vous contactera très bientôt.');
        resetForm(formData.city);
      } else {
        setSubmitMessage('Une erreur est survenue. Veuillez réessayer ou appelez directement.');
      }
    } catch {
      setSubmitMessage('Erreur de connexion. Veuillez appeler directement au ' + phoneNumber);
    } finally {
      setIsSubmitting(false);
    }
  }, [formData, resetForm]);

  const setCityName = useCallback((name) => {
    setFormData(prev => ({ ...prev, city: name }));
  }, []);

  return {
    formData,
    isSubmitting,
    submitMessage,
    handleInputChange,
    handleSubmit,
    setCityName,
  };
};

export default useCityForm;
